import React from 'react'
import {ReactComponent as ArrowUp} from '../../assets/icons/arrow-up.svg'

const ArrowUpIcon = () => {
    return <ArrowUp />
}

export default ArrowUpIcon
